import { render, staticRenderFns } from "./tpaga.vue?vue&type=template&id=74b29a13&"
import script from "./tpaga.vue?vue&type=script&lang=js&"
export * from "./tpaga.vue?vue&type=script&lang=js&"
import style0 from "./tpaga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopScreen: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/TopScreen.vue').default,FooterTop: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/footer/footerTop.vue').default})
